export const styles = {
  mono: {
    fontFamily: 'monospace',
  },
};

export const isRunning = (state) => state == 'active';

export const isDone = (state) => ['completed', 'failed'].includes(state);
